export default "__VITE_ASSET__BS9O_Uo7__"